import React, { FC } from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';

export interface TimelineItemProps {
    children?: React.ReactNode;
    isLast?: boolean;
}

export const TimelineItem: FC<TimelineItemProps> = ({ children, isLast = false }) => (
    <Stack gap="3" paddingBottom="3">
        <Stack width="40px" flexShrink={0} justifyContent="center" paddingTop="2">
            <Container>
                <Container width="8px" height="8px" backgroundColor="grey_600" borderRadius="circle" />
                <Container
                    width="1px"
                    backgroundColor="grey_500"
                    height="100%"
                    marginTop="2"
                    marginLeft="1"
                    style={{
                        height: isLast ? '0' : 'calc(100% - 4px)',
                    }}
                />
            </Container>
        </Stack>
        <Stack direction="column" minWidth={0} flexGrow={1}>
            {children}
        </Stack>
    </Stack>
);
